import React, { Fragment } from "react"
import { withStyles } from "@material-ui/core/styles"
import { Grid, Box, Card, Typography } from "@material-ui/core/"
import styles from "./styles"

const SideBox = ({ classes, ...props }) => {
  return (
    <Fragment>
      <Box display="flex" flexWrap="wrap" className={classes.sideBoxContainer}>
        <Card className={classes.sideBoxCard} elevation={2}>
          <Grid className={classes.titleContainer} item>
            <Typography className={classes.cardTitle} variant="h3">
              {props.title}
            </Typography>
            {props.subtitle && (
              <Typography
                variant="body1"
                color="secondary"
                className={classes.subTitle}
              >
                {props.subtitle}
              </Typography>
            )}
          </Grid>
          <Box>{props.content}</Box>
        </Card>
      </Box>
    </Fragment>
  )
}

export default withStyles(styles)(SideBox)



// WEBPACK FOOTER //
// ./src/components/SideBox/index.jsx